import React, { useRef, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { clampFrac, pinPositionText, useAnimationFrame } from '../util'
import useStore from '../AppStore'

const Slides = ({text, start, end}) => {

  const top = useStore(s=>s.top)
  const line = clampFrac(top, start, end)
  const len = text.length
  const current = Math.min(Math.floor(line*len),len-1)

  return (
    <AnimatePresence exitBeforeEnter>
      {text.map((slide,i)=>{
        return i == current
          ? (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
          >
            {slide}
          </motion.div>
          )
          : null
      })}
    </AnimatePresence>
  )
}

export default function Text(props) {
  
  const {start, end} = props

  const divRef = useRef(null)
  const lineRef = useRef(null)

  useAnimationFrame(deltaTime => {

    const top = useStore.getState().top
    const opacity = top < start - 500 || top > end + 300
      ? 0
      : top < start
        ? 1 - textOpacity(top, start-300, start)
        : textOpacity(top, end, end + 300)
    
    if(divRef.current){  
      divRef.current.style.display = opacity > 0 ? 'block' : 'none'
      divRef.current.style.opacity = opacity
      if(opacity){
        const y = pinPositionText(top, start, end)
        divRef.current.style.transform = `translate3d(0px,${y}px,0)`
      }
    }

    if(opacity && lineRef.current){
      const line = clampFrac(top, start, end)
      lineRef.current.style.height = `${line*180}px`
    }

  })

  return (
    <div ref={divRef} className={`text-block ${props.align || 'center'}`}>
      <div ref={lineRef} className="text-block--progress"></div>
      <div className="text-block--content">
        <h2>{props.title}</h2>
        {props.text && <Slides text={props.text} start={start} end={end} />}
      </div>
    </div>
  )
}


function textOpacity(top, low, high) {
  return top > low ? 1 - clampFrac(top,low,high) : 1
}
